// export const API = 'http://localhost:5000'
export const API = 'https://combater-prod-actual.herokuapp.com'

/**@type { 'development' | 'production' } */
export const MODE = 'production'
